import { stages } from '@innovamat/radiance-utils';

import type { ClassroomStudent } from '../../views/classroom-students/types/classroom-student';
import type { SchoolStudent } from '../../views/school-students/types/student';

const applyAvatarStageRules = (
  student: ClassroomStudent | SchoolStudent,
  courseOrder?: number
): string | null => {
  return stages.isInfantil(courseOrder ? courseOrder : student.courseOrder)
    ? student.avatar
    : null;
};

const parseStudent = <T extends ClassroomStudent | SchoolStudent>(
  student: T
): T => ({
  ...student,
  avatar: applyAvatarStageRules(student),
});

const parseStudents = <T extends ClassroomStudent | SchoolStudent>(
  students: T[]
): T[] => students.map(parseStudent);

const hasDemoStudent = <T extends ClassroomStudent | SchoolStudent>(
  students: T[]
): boolean => {
  return students.some(
    (student) => student && 'isDemo' in student && student.isDemo
  );
};

export { applyAvatarStageRules, hasDemoStudent, parseStudent, parseStudents };
